import React, { FunctionComponent } from "react";
import { HashRouter as RouterOriginal, Route as RouteOriginal } from "react-router-dom";
import NotificationRequestScreen from "@pages/notificationRequest";
import UserActivationScreen from "@pages/userActivationRequest";
import ServicesAssociationsScreen from "@pages/servicesAssociations";

const Route: any = RouteOriginal;
const Router: any = RouterOriginal;

const Routes: FunctionComponent = () => (
  <Router>
    <Route exact path="/notificationRequest" component={NotificationRequestScreen} />
    <Route exact path="/activeUserRequest" component={UserActivationScreen} />
    <Route exact path="/servicesAssociations" component={ServicesAssociationsScreen} />
  </Router>
);

export default Routes;
